<template>
  <div>
    <v-row>
      <v-col cols="12" md="3">
        <account-avatar-manager></account-avatar-manager>
      </v-col>
      <v-col cols="12" md="9">
        <account-credentials></account-credentials>
      </v-col>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="12" md="9">
        <account-user-groups></account-user-groups>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AccountAvatarManager from '@/components/admin/account/AccountAvatarManager';
import AccountCredentials from '@/components/admin/account/AccountCredentials';
import AccountUserGroups from '@/components/admin/account/AccountUserGroups';

export default {
  components: {
    AccountCredentials,
    AccountUserGroups,
    AccountAvatarManager,
  },
};
</script>
